export default __webpack_public_path__ + "811c472e1f1ef30c57d1fa118d9edb1c.svg";